import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionCancel() {
  return (
    <div
      className="min-h-screen bg-[#0A0E1A] text-[#F1F5F9] flex items-center justify-center px-4"
      data-testid="subscription-cancel-page"
    >
      <div className="max-w-md w-full bg-[#141923] border border-[#2A3447] rounded-xl p-8 text-center">
        <XCircle className="w-14 h-14 text-[#94A3B8] mx-auto" />
        <h1 className="mt-5 text-2xl font-bold">Pago cancelado</h1>
        <p className="text-sm text-[#94A3B8] mt-2">
          No te preocupes, no se cobró nada. Puedes reintentar cuando estés listo.
        </p>
        <Link to="/dashboard">
          <Button className="mt-6 w-full bg-[#3B82F6] hover:bg-[#2563EB]">
            Volver al dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
